import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LoginFacade } from '@cigna/cigna-for-brokers/login-data-access';
import { AppstateFacade } from '@cigna/cigna-for-brokers/shell/data-access';
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { CookieService } from 'ngx-cookie-service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'cigna-cfb-logout',
  template: '',
})
export class CfbLogoutComponent implements OnInit, OnDestroy {
  isOktaLoginEnabled: boolean;
  private _ngUnsubscribe$: Subject<void> = new Subject<void>();
  isOktaLoginEnabled$ = this.featureTogglesFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    private _login: LoginFacade,
    private router: Router,
    private _cookie: CookieService,
    private featureTogglesFacade: FeatureTogglesFacade,
    private appstateFacade: AppstateFacade,
  ) {}

  ngOnInit(): void {
    this.isOktaLoginEnabled$
      .pipe(takeUntil(this._ngUnsubscribe$))
      .subscribe((isOktaLoginEnabled) => {
        this.isOktaLoginEnabled = isOktaLoginEnabled;
      });

    this.appstateFacade.logOut({ variation: 'logout', linkName: 'logout' });
    this._login.logout('logout');
    this._cookie.delete('accessToken', '/');
    this.router.navigate(['/public/login']);
  }

  ngOnDestroy() {
    this._ngUnsubscribe$.unsubscribe();
  }
}
